jQuery(document).ready(function($){
    // make editor embed videos responsive
    $('.Editor iframe').each(function(){
        $(this).wrap('<div class="my-3"><div class="embed-responsive embed-responsive-16by9"></div></div>');
    });
});